import { z } from 'zod';

import {
    allowEmptyString,
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createShoppingListProductAddSchema = () =>
    z
        .object({
            id: requiredString,
            user_id: requiredString,
            organisation_id: requiredString,
            shopping_list_id: requiredString,
            product_id: requiredString,
            product_sales_unit_id: allowEmptyString,
            unit_type: requiredString,
            quantity: requiredNumber,
            total_quantity: requiredNumber,
            created_at: timestamp,
            updated_at: timestamp,
        })
        .strict();

export const createShoppingListProductUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createShoppingListProductAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.shopping_list_products,
    );

export const createShoppingListProductDeleteSchema = () => createDeleteSchema();

export const createShoppingListProductSchemas = () => ({
    add: createShoppingListProductAddSchema(),
    update: createShoppingListProductUpdateSchema(),
    delete: createShoppingListProductDeleteSchema(),
});

export const shoppingListProductRawRecordSchema =
    createShoppingListProductAddSchema();
